import { render, staticRenderFns } from "./FooterModals.vue?vue&type=template&id=5347b1c4&scoped=true&lang=pug&"
import script from "./FooterModals.vue?vue&type=script&lang=ts&"
export * from "./FooterModals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5347b1c4",
  null
  
)

export default component.exports